import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import { getAddToScheduleRequest } from 'state/scheduledRuns/selectors';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';
import { type HttpError, toTypedError } from 'utils/http/httpClient.model';

export function addToScheduledRunEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) => {
    const { updateRunRequest } = scheduledRunsApi(httpClient);

    return actions$.pipe(
      ofType('SCHEDULED_RUN_ADD_TO_SCHEDULE_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ id }, state]) => {
        const req = getAddToScheduleRequest(state, id);
        if (!req) {
          return EMPTY;
        }
        return updateRunRequest(req.runId, req.etag, req.request, getWorkspaceType(state, id)).pipe(
          map(() => scheduledRunActions.addToScheduleSucceeded(id, req.runId)),
          catchError((err: HttpError) => {
            return of(
              scheduledRunActions.addToScheduleFailed(id, toTypedError('Pricing Runs DIY', err)),
              scheduledRunActions.scheduledRunRunsRequested(id),
            );
          }),
        );
      }),
    );
  };
}
